import styled from 'styled-components';

const StyledH3 = styled.h3`
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: ${(props) => props.theme.colors.dark};
`;

export default StyledH3;
